// extracted by mini-css-extract-plugin
module.exports = {"container":"About-module--container--1YR_k","wrapper":"About-module--wrapper--3t95L"};